/**
 * Общая реализация onKendoFiltering для сервисов автокомплита.
 */
export const applyOnKendoFiltering = async (
    e: kendo.ui.ComboBoxFilteringEvent,
    getPredictions: (input: string) => Promise<Array<{ text: string; value: string }>>
) => {
    const { filter, sender } = e;
    const value = filter?.value ?? sender.value();

    if (value.length < 3) {
        return;
    }

    const data = await getPredictions(value);
    const dataSource = new kendo.data.DataSource({ data });

    sender.setDataSource(dataSource);
    window.rebindDataSource(sender);
};
